<p-dialog [(visible)]="visible" appendTo="body" [modal]="!deviceManager.isMobile" [closable]="false" [showHeader]="true"
          [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '800px'}"
          styleClass="select-categories-dialog">
    <p-header>
        <div>{{title}}</div>
        <div *ngIf="noCategoriesMeansAllUsers" class="target-message">(Do not select any categories if you want to target all {{childrenMode ? 'children' : 'users'}})</div>
    </p-header>
    <div class="select-categories-dialog-body">
        <div class="category-types-area">
            <div class="category-types">
                <div *ngFor="let categoryType of orgCategoryItemTypes" class="category-type">
                    <button pButton pRipple type="button" [disabled]="orgCategoriesByType.get(categoryType)!.length === 0"
                            [class]="'cat-type-' + categoryType" [class.selected]="categoryType === currentCategoryType"
                            (click)="onCategoryTypeClicked(categoryType)">
                        <fa-icon *ngIf="!deviceManager.isMobile" [icon]="getCategoryItemTypeIcon(categoryType)" size="1x"></fa-icon>
                        <span>{{MyCampApp.getCategoryItemTypeString(categoryType)}}</span>
                    </button>
                    <div class="num-categories-selected">{{selectedCategoriesByType.get(categoryType)!.length}} of {{orgCategoriesByType.get(categoryType)!.length}}</div>
                </div>
            </div>

            <div *ngIf="allowSelectAll && currentCategoryType !== undefined" class="select-all">
                <p-checkbox [label]="selectAll ? 'Unselect All' : 'Select All'" [binary]="true" [(ngModel)]="selectAll" (onChange)="onSelectAllChanged($event.checked)"></p-checkbox>
            </div>
        </div>

        <div class="selection-area">
            <div *ngIf="currentCategoryType != undefined" class="category-checkbox-list">
                <div *ngFor="let categoryItem of orgCategoriesByType.get(currentCategoryType!)" class="category-checkbox-item">
                    <p-checkbox name="groupname" [value]="categoryItem" [label]="getCategoryName(categoryItem)" [disabled]="isDisabledCategoryItem(categoryItem)"
                                [(ngModel)]="selectedCategories" (ngModelChange)="onSelectedCategoriesChanged()">
                    </p-checkbox>
                </div>
            </div>
            <div *ngIf="showUserCount" class="selection-info-area" [class.bordered]="currentCategoryType != undefined">
                <div class="chart" [class.narrow]="deviceManager.isMobile || currentCategoryType !== undefined">
                    <highcharts-chart #chart *ngIf="pieChart" [Highcharts]="Highcharts" [options]="pieChart!" [callbackFunction]="chartCallback.bind(this)" ></highcharts-chart>
                </div>
                <div *ngIf="childrenCountResult || memberCountResult" class="member-count-text">
                    <div class="text">Number of {{childrenMode ? 'children' : 'app users'}} targeted:</div>
                    <div class="number-of-matches">
                        <div>{{selectedUserCount}} of {{totalUserCount}}</div>
                        <div class="percent">({{totalUserCount === 0 ? "0" : Math.floor(selectedUserCount / totalUserCount * 100)}}%)</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button pButton type="button" class="p-button-secondary" icon="pi pi-times" label="Cancel" (click)="onCancel()"></button>
        <button pButton type="button" label="Done" icon="pi pi-check" (click)="onOk()"></button>
    </ng-template>
</p-dialog>
